function a(r, e) {
  return (e & r.orderFormat) === e;
}
export {
  a as default
};
